export enum Environments {
  Local = 'local',
  Dev = 'dev',
  Stage = 'stage',
  Prod = 'prod',
}
